/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CircleButtonAdd } from '@components/circle-button-add';
import { AlertDialog, Box, Checkbox } from '@components/design-system';
import * as Styles from '@components/modals/styles';
import { boardTokenAdd, boardTokenRemove, GetUserBoardsContainingToken } from '@lib/versum';
import { actions as globalActions } from '@state/global';
import { actions } from '@state/modals';
import { RootState } from '@state/store';

export interface ITokenSave {
  open?: boolean;
  onOpenChange?: (value: boolean) => void;
  tokenId?: any;
  viewer?: string;
}

interface ICell {
  id: string;
  selected: boolean;
  label: string;
}

// TODO: this might need some refactoring to avoid calling FetchUserBoards on first time
export const TokenSave: FC<ITokenSave> = ({ open, onOpenChange, viewer, tokenId }) => {
  const dispatch = useDispatch();
  const storeBoards = useSelector((e: RootState) => e.global.boards);
  const [boards, setBoards] = useState<ICell[]>([]);

  const FetchUserBoards = async () => {
    const boardsContainingToken = await GetUserBoardsContainingToken(viewer!, tokenId);

    const nextBoards = storeBoards.map((b: any) => {
      const selected = boardsContainingToken.token_lists.find((e: any) => e.id === b.id) !== undefined;
      return { id: b.id, selected, label: b.title };
    });

    setBoards(nextBoards);
  };

  const handleConfirm = () => {
    if (onOpenChange) {
      onOpenChange(false);
    }
  };

  const handleCancel = () => {
    if (onOpenChange) {
      onOpenChange(false);
    }
  };

  const handleNewBoard = async () => {
    const callback = () => {
      const user = { id: viewer };
      dispatch({ type: globalActions.GLOBAL_GET_BOARDS, payload: user });
      dispatch({ type: actions.MODALS_SET_MODAL, payload: { type: 'token-save', tokenId, viewer } });
    };
    dispatch({ type: actions.MODALS_SET_MODAL, payload: { type: 'board-create', callback } });
  };

  const handleTokenAdd = async (boardId: string) => {
    await boardTokenAdd(boardId, tokenId);
  };

  const handleTokenRemove = async (boardId: string) => {
    await boardTokenRemove(boardId, tokenId);
  };

  const handleChange = (id: string, selected: boolean) => {
    const board = boards.find((e: any) => e.id === id);
    if (board) {
      const index = boards.indexOf(board);
      const items: ICell[] = [...boards];
      const item: ICell = items[index];
      item.selected = selected;
      items[index] = item;
      setBoards(items);

      if (selected) {
        handleTokenAdd(id);
      } else {
        handleTokenRemove(id);
      }
    }
  };

  useEffect(() => {
    FetchUserBoards();
  }, [storeBoards]);

  return (
    <AlertDialog
      title="Add to Board"
      description="You can add the token to multiple boards."
      open={open}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    >
      <Styles.Content>
        {boards.length > 0 && (
          <Box
            css={{
              flexDirection: 'column',
              height: boards.length >= 4 ? 180 : boards.length * 50 + 2,
              overflowY: 'auto',
              borderRadius: 5,
              border: '1px solid $colors$primaryBorder',
            }}
          >
            <Box
              css={{
                flexDirection: 'column',
                '&>*:last-child': {
                  borderBottom: 'none',
                },
              }}
            >
              {boards.map((board: ICell) => {
                return (
                  <Box
                    vertical
                    key={board.id}
                    css={{
                      height: 50,
                      padding: '0 $space$3',
                      cursor: 'pointer',
                      borderBottom: '1px solid $colors$primaryBorder',
                      '&:hover': { backgroundColor: '$secondaryBackground' },
                      '&:focus-within': { backgroundColor: '$secondaryBackground' },
                    }}
                  >
                    <Checkbox
                      reversed
                      label={board.label}
                      value={board.selected}
                      onChange={(value: boolean) => handleChange(board.id, value)}
                      css={{ width: '100%', height: '100%' }}
                    />
                  </Box>
                );
              })}
            </Box>
          </Box>
        )}
        <Box css={{ margin: '$space$3 0' }}>
          <CircleButtonAdd label="New Board" onClick={handleNewBoard} />
        </Box>
      </Styles.Content>
    </AlertDialog>
  );
};
